import IRootPageLink from '@/types/IRootPageLink';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const MIN_NUMBER_OF_LINKS_REQUIRED_TO_DISPLAY_SEARCH = 5;

interface IProps {
	name: string;
	description: string;
	links: Array<IRootPageLink>;
}

export function useRootPageTemplate(props: IProps) {
	const { t } = useTranslation();
	const form = useForm({ defaultValues: { search: '' } });

	const filteredLinks = props.links.filter((link) => {
		return (
			link.name.toLowerCase().includes(form.watch('search').toLowerCase()) ||
			link.description?.toLowerCase().includes(form.watch('search').toLowerCase()) ||
			Object.values(link.tags || {}).some((tag) => tag.toLowerCase().includes(form.watch('search').toLowerCase()))
		);
	});

	return { t, form, filteredLinks };
}
